import { Button, CheckChunkierIcon, Typography } from '@eventbrite/marmalade';
import { useIntl } from 'react-intl';
import { messages } from './constants';
import styles from './SuccessView.module.scss';

interface Props {
  onDone: () => void;
}

export function SuccessView({ onDone }: Props) {
  const intl = useIntl();

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.iconCircle}>
          <CheckChunkierIcon size="large" />
        </div>
        <Typography variant="heading-sm">{intl.formatMessage(messages.successTitle)}</Typography>
        <Typography variant="body-md" color="neutral-600">
          {intl.formatMessage(messages.successSubtitle)}
        </Typography>
      </div>

      <div className={styles.actions}>
        <Button variant="secondary" onClick={onDone}>
          {intl.formatMessage(messages.doneButton)}
        </Button>
      </div>
    </div>
  );
}
